import * as React from 'react';
import { useParams } from 'react-router-dom';
import { PaymentOut } from 'cb-model';
import { Display, NavIconContainer, PageTitle, QuerySingle, Section } from 'gossamer-front-end';

/**
 * PaymentOut Display Page
 *
 * Display details for a single outbound payment record (read-only)
 */
export const PaymentOutDisplay = (): React.JSX.Element => {
  const params = useParams();

  return (
    <>
      <NavIconContainer entityId={PaymentOut.id} />
      <PageTitle verb="Display" entity={PaymentOut} keyValue={params.key} />

      <Section>
        <QuerySingle entity={PaymentOut} keyValue={params.key} render={Display} />
      </Section>
    </>
  );
};
